import { useRouter } from 'next/router';

import { icon_search } from '@gn-audio/icons';

import useFallbackTranslation from '../../../utils/hooks/useFallbackTranslation';
import { JabraIcon } from '../../JabraIcon/JabraIcon';

type SearchButtonProps = {
  onClick: () => void;
  isActive?: boolean;
};

export const SearchButton = ({ onClick, isActive }: SearchButtonProps): JSX.Element => {
  const router = useRouter();
  const { t } = useFallbackTranslation();
  const path = router.asPath;

  return (
    <>
      {!path.includes('search') ? (
        <>
          <button
            title={t('topmenu.Search')}
            aria-label={t('topmenu.Search')}
            onClick={onClick}
            className={`search-button btn-top-menu ${isActive && 'active'}`}
          >
            <JabraIcon Icon={icon_search} className="size-6" />
          </button>
        </>
      ) : null}
    </>
  );
};
